import { CalendarClock } from 'lucide-react';

import { NodeShell } from './NodeShell';

interface Data {
  label: string;
  delayDays?: number;
  atTime?: string;
  runAt?: string;
}

const describe = (d: Data): string => {
  if (d.runAt) return `at ${d.runAt}${d.atTime ? ` · ${d.atTime}` : ''}`;
  const days = d.delayDays ?? 0;
  const when = days === 0 ? 'today' : days === 1 ? 'in 1 day' : `in ${days} days`;
  return d.atTime ? `${when} at ${d.atTime}` : when;
};

export const ScheduleWorkflowNode = ({ data, selected }: { data: Data; selected?: boolean }) => (
  <NodeShell
    type="schedule_workflow"
    icon={<CalendarClock size={16} />}
    label={data.label}
    subtitle={describe(data)}
    selected={selected}
  />
);
